export enum WorkInstanceStateColor {
  Unspecified = "orange",
  PendingFuture = "#2584F1",
  PendingPast = "#F00D0D",
  Active = "#47D325",
  Finished = "#B9B9B9",
}
